import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";

import { userActions } from "../_actions";
import { LoginForm } from "./LoginForm";
import { RegisterForm } from "./RegisterForm";
import "./LoginPage.css";
import { images } from "../_assets";
import { THEME } from "../_constants";

const styles = theme => ({
    logo: {
        margin: 44,
        width: 175,
        height: 42
    },
    tabsIndicator: {
        marginLeft: 25,
        maxWidth: 75,
        height: 5,
        backgroundColor: THEME.COLOR.GREEN
    },
    tabRoot: {
        textTransform: "initial",
        minWidth: 72,
        fontWeight: theme.typography.fontWeightLight,
        marginRight: theme.spacing.unit * 4,
        "&$tabSelected": {
            color: "black",
            fontWeight: theme.typography.fontWeightMedium
        }
    },
    tabSelected: {},
    heading: {
        width: 350,
        color: "white",
        fontSize: theme.typography.pxToRem(25),
        marginTop: 250,
        marginLeft: 40,
        lineHeight: 1.67,
        fontWeight: 500
    }
});

class LoginPage extends React.Component {
    constructor(props) {
        super(props); // reset login status
        this.props.dispatch(userActions.logout());
        this.state = {
            tab: 0
        };
    }

    handleSwitchTab = (event, tab) => {
        this.setState({ tab });
    };

    render() {
        const { t, classes } = this.props;
        const { tab } = this.state;
        const self = this;

        function renderLeftArea() {
            return (
                <div
                    className="leftArea"
                >
                    <img
                        className={classes.logo}
                        src={images.adzLogo}
                        alt="bg"
                    />
                    <Typography variant="headline" className={classes.heading}>
                        {t("Slogan")}
                    </Typography>
                </div>
            );
        }

        function renderRightArea() {
            return (
                <div
                    style={{
                        flex: 1,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div className="loginForm">
                        <Tabs
                            value={self.state.tab}
                            onChange={self.handleSwitchTab}
                            classes={{
                                root: classes.tabsRoot,
                                indicator: classes.tabsIndicator
                            }}
                        >
                            <Tab
                                label={t("Login")}
                                disableRipple
                                classes={{
                                    root: classes.tabRoot,
                                    selected: classes.tabSelected
                                }}
                            />
                            <Tab
                                label={t("Register")}
                                disableRipple
                                classes={{
                                    root: classes.tabRoot,
                                    selected: classes.tabSelected
                                }}
                            />
                        </Tabs>
                        {tab === 0 && <LoginForm />}
                        {tab === 1 && <RegisterForm />}
                    </div>
                </div>
            );
        }

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    display: "flex",
                    flexDirection: "row"
                }}
            >
                {renderLeftArea()}
                {renderRightArea()}
            </div>
        );
    }
}

LoginPage.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
}

const connectedLoginPage = connect(mapStateToProps)(
    translate("translations")(LoginPage)
);

const styledLoginPage = withStyles(styles)(connectedLoginPage);

export { styledLoginPage as LoginPage };



// WEBPACK FOOTER //
// ./src/LoginPage/LoginPage.jsx